// extracted by mini-css-extract-plugin
export default {"reviewCards":"reviewCards_yRYgv","reviewCard":"reviewCard_rJ10N"};